// ** Modules
import React from 'react';

// ** UI
import Typography from '@mui/material/Typography';

// ** Translation
import { useTranslation } from 'next-i18next/pages';

type PriceInfoProps = {
	label: string;
	value?: number | string | null;
	highlight: boolean;
	suffix?: string;
	priceWithoutTax: boolean;
	extraPersonLabel?: string;
	extraPersonValue?: number | string | null;
};

const PriceInfo: React.FC<PriceInfoProps> = ({
	label,
	value,
	highlight = false,
	suffix = '',
	priceWithoutTax = true,
	extraPersonLabel,
	extraPersonValue
}) => {
	const { t } = useTranslation();

	const formatValue = (value: number | string | null | undefined) =>
		value === null || value === undefined || value === '' ? '-' : `${value}${suffix}`;

	const priceWithoutTaxLabel = t('common:price_without_tax_short');

	return (
		<React.Fragment>
			<Typography
				component="h5"
				variant="body-md"
				color={highlight ? 'primary' : undefined}
				sx={{ textAlign: 'start' }}
			>
				{label}:
			</Typography>

			<Typography component={highlight ? 'h5' : 'p'} variant="body-md" sx={{ textAlign: 'start' }}>
				{formatValue(value)}{' '}
				{priceWithoutTax && (
					<Typography component="span" variant="caption">
						{priceWithoutTaxLabel}
					</Typography>
				)}
			</Typography>

			{extraPersonValue !== undefined && extraPersonValue !== null && (
				<React.Fragment>
					<Typography
						component="p"
						variant="caption"
						color={highlight ? 'primary' : undefined}
						sx={{ textAlign: 'start' }}
					>
						{extraPersonLabel}
					</Typography>

					<Typography variant="body-md" sx={{ textAlign: 'start' }}>
						{formatValue(extraPersonValue)}{' '}
						{priceWithoutTax && (
							<Typography component="span" variant="caption">
								{priceWithoutTaxLabel}
							</Typography>
						)}
					</Typography>
				</React.Fragment>
			)}
		</React.Fragment>
	);
};

export default PriceInfo;
